module.exports = {"loading":"Loading, please wait..."}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en.json
// module id = ./src/locale/en.json
// module chunks = 0